import { render } from "./pengajuan-list.vue?vue&type=template&id=941e00fc"
import script from "./pengajuan-list.vue?vue&type=script&lang=js"
export * from "./pengajuan-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__